(function () {
  'use strict';

  angular.module('sempraWebapp').factory('MessageTypeEnum', messageTypeEnumFactory);

  /** @ngInject */
  function messageTypeEnumFactory () {
    return Object.freeze({
      ALARM: 'alarm',
      INFO: 'info',
      WARNING: 'warning'
    });
  }
})();
